import { Component, Inject } from "@angular/core";
import { GeoAppInjectionToken, IGeoAppAppInjectionToken, StartPageComponent } from "@geolib/geoappbase-client";
import { UIView } from "@uirouter/angular";

@Component({
    selector: "home",
    templateUrl: "./home.component.html",
    imports: [UIView, StartPageComponent],
})
export class HomeComponent {
    public constructor(
        @Inject(GeoAppInjectionToken) private readonly geoappSettings: IGeoAppAppInjectionToken,
    ) {
    }

    public get appNamePrefix(): string {
        return this.geoappSettings.appNamePrefix;
    }

    public get appNameSuffix(): string {
        return this.geoappSettings.appNameSuffix;
    }
}
